// @ts-check
// import key from "keymaster";
import queryString from "query-string";
import Storage from "browserstorage-ttl";
import { notification } from "antd";
// import userflow from "userflow.js";
import { getIntercomSettings } from "../utils/intercom";
import { handleError } from "../utils/api";
import moment from "moment";
// import { AppContext } from "../app-context";
import {
  ProjectsApi,
  SaasOnlyApi,
  UsersApi,
  CompaniesApi,
  SettingsApi,
  TestCasesApi,
  StatusesApi, // Added StatusesApi
} from "../services/generated-sdk";
import trackEvent from "../common/utils";
import { storeUserSession, refreshSessionTTL } from "../utils/common-ts";
// import { getIntercomSettings } from "../utils/common";
import { LoadFullstory } from "../scripts/LoadFullstory";
import { onLogout, fetchFeatureStatus } from "../utils/data-residency";
import {
  normalizeOnboardingInfo,
  coerceBooleanFlag,
} from "../utils/onboarding";
import { isAiOptedOut } from "../utils/common";

const _ = require("lodash");

// TCV-6854: feature flags that switch on an AI surface. When the company has
// opted out of AI they are dropped from `enabledFeatures`, which is what every
// AI screen already checks — so one rule turns them all off at once. The
// unfiltered list is kept in `enabledFeaturesRaw` so flipping the setting back
// on restores them without a re-login.
const AI_FEATURE_FLAGS = ["qa_copilot", "qa_copilot_bulk_automation"];

const applyAiOptOut = (enabledFeatures, company) => {
  const features = Array.isArray(enabledFeatures) ? enabledFeatures : [];
  if (!isAiOptedOut(company)) {
    return features;
  }
  return features.filter((feature) => AI_FEATURE_FLAGS.indexOf(feature) < 0);
};

// TCV-6854: the company-wide opt-out overrides the per-project QA Copilot
// setting, so every screen reading projectSettingsByKey.enable_copilot sees it
// as off without each of them needing its own opt-out check.
const applyAiOptOutToProjectSettings = (projectSettingsByKey, company) => {
  const settings = projectSettingsByKey || {};
  if (!isAiOptedOut(company) || !settings["enable_copilot"]) {
    return settings;
  }
  return {
    ...settings,
    enable_copilot: { ...settings["enable_copilot"], value: "0" },
  };
};
// const getProjectTags = async projectId => { // Commented out again
//   try {
//     const API = new TestCasesApi();
//     const data = await API.getTestCasesTags({ project: projectId });
//     return data;
//   } catch (e) {
//     return [];
//   }
// };
function setDocumentTitle(title) {
  document.title = title;
}
function inIframe() {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
}

/*

const delay = timeout => new Promise(resolve => setTimeout(resolve, timeout));

*/
const delay = (timeout) =>
  new Promise((resolve) => setTimeout(resolve, timeout));

const handleFlashMessages = (queryParams) => {
  const values = queryString.parse(queryParams);
  if (values.msg) {
    let messageType = "info";
    if (values.msgType) {
      messageType = values.msgType.toString();
    }
    // notification[messageType]({
    //   message: "",
    //   description: values.msg,
    // });
  }
};

const getProjectId = (url) => {
  let projectId = false;
  let urlParts = url.replace("/new", "").split("/");
  if (urlParts[1] == "project") {
    projectId = urlParts[2];
  }
  return projectId;
};

const setAuthGlobals = ({ jwt }) => {
  window["JWT"] = jwt;
  window["API_KEY"] = "49468cb06e4bd5184d2f19b92fc9ca8c17d24aea"; // delete me later once v1 api is expired
};

export default {
  namespace: "app",
  state: {
    projectId: false,
    projectTitle: "",
    projectTestCaseCount: null,
    users: [],
    userIndex: [],
    onlineUsers: [],
    ready: false,
    breadCrumb: [],
    pageTitle: "",
    loggedIn: false,
    isModal: false,
    loggedInUser: {},
    navExpanded: true,
    projects: [],
    companyUsers: [],
    lastAccessedProjects: [],
    config: {},
    keyboardShortcutModal: false,
    company: {}, // selected company/workspace
    isCompanyQualified: null,
    companies: [], // companies that user is part of
    defectsEnabled: false,
    requirementsEnabled: false,
    projectTags: [], // Changed from false to [] for consistency
    projectStatuses: [], // Added projectStatuses
    featureModal: {
      visible: false,
      title: "Upgrade Required",
      content: null,
      feature: null,
    },
    ssoInfo: {},
    enabledFeatures: [],
    enabledFeaturesRaw: [], // TCV-6854
    copilotUser: null,
    projectMembers: [],
    projectUsers: [],
    projectSettingsByKey: {},
    projectLock: {
      trackedProjectId: null,
      dismissed: false,
    },
  },
  subscriptions: {
    setup({ history, dispatch }) {
      //history.push("/project/1/dfds");

      // one-time run functions

      /*
      console.info("binding AppModel subscription...");
      bindEvent(window, "message", function(e) {
        if (e.data.type) {
          if (e.data.type == "oldAppLinkClick") {
            if (e.data.url.indexOf("javascript") > -1) {
              return;
            }
            console.info("Link called from legacy app ", e.data.url);
            let targetURL = e.data.url;
            targetURL = targetURL.replace("legacy/index.php/", "");
            targetURL = targetURL.replace("new", "");
            targetURL = targetURL.replace("//", "/");
            location.hash = targetURL;
          }
        }
      });*/

      // setup pinger
      const pingServer = function () {
        dispatch({
          type: "pingServer",
        });

        //setTimeout(pingServer, 5000);
      };

      // disabled for now - activate in some later version
      // setTimeout(pingServer,5000);

      // Subscribe history(url) change, trigger `load` action if pathname is `/`
      return history.listen((opts) => {
        let pathname = opts.pathname;

        pingServer();

        //setActiveNav();

        // flash message handler
        handleFlashMessages(opts.search);

        dispatch({
          type: "fetchUsers",
        });

        //legacyNavHandler(pathname);
        // set current project id

        // if its not a project page
        if (pathname.indexOf("/project/") == -1) {
          dispatch({
            type: "setProjectDetails",
            payload: {
              projectId: false,
              projectArchived: false,
              projectTitle: "",
              defectsEnabled: false,
              requirementsEnabled: false,
              projectMembers: [],
              projectUsers: [],
              projectTags: [],
              projectStatuses: [], // Added projectStatuses
              projectTestCaseCount: null,
            },
          });
        } else {
          // this is a project page
          const projectId = getProjectId(pathname);

          dispatch({
            type: "setReady",
            payload: { ready: false },
          });

          // is it same project as last state?
          dispatch({
            type: "fetchProjectInfo",
            payload: { projectId },
          });

          /*
          // fetch project members
          dispatch({
            type: "fetchProjectUsers",
            payload: { projectId }
          });
          */

          dispatch({
            type: "setReady",
            payload: { ready: true },
          });

          // if project memebers index is loaded, fetch project users again as they might be modified
          if (pathname.indexOf("/project_members/") != -1) {
            dispatch({
              type: "fetchProjectUsers",
              payload: { projectId: projectId, hardRefresh: true },
            });
          }
        }

        if (window.Intercom != undefined) {
          //console.log("Updating intercom settings on route change");
          window.Intercom("update");
        }
      });
    },

    keyboardWatcher({ dispatch, history }) {
      // key("⌘+up, ctrl+up", () => {
      //   alert("Hey mate, all good here...");
      // });
      // key("t", () => {
      //   alert("Sorry I have a bug, cant work...");
      //   //let history1 = createHistory();
      //   //let history1 = createBrowserHistory()
      //   //history.push("/project/1/keyboardWatcher");
      //   //location.pathname = "/project/1/keyboardWatcher";
      // });
    },
  },
  reducers: {
    setBeyboardShortcutModal(state, { payload }) {
      return {
        ...state,
        keyboardShortcutModal: payload.show,
      };
    },
    setNavExpanded(state, { payload }) {
      return {
        ...state,
        navExpanded: payload.status,
      };
    },
    setLoggedInUser(state, { payload }) {
      const userPref =
        payload.user && payload.user.preferences
          ? payload.user.preferences
          : {};
      let sortedProjects = [];
      if (typeof userPref == "object") {
        // sortedProjects = _.sortBy(userPref.lastAccessedProjects, ["last_accessed"]);
      }

      //debugger;
      return {
        ...state,
        loggedIn: payload.user ? true : false,
        loggedInUser: payload.user,
        lastAccessedProjects:
          userPref.last_accessed_projects ||
          userPref.lastAccessedProjects ||
          [],
      };
    },
    setLoggedInUserToken(state, { payload }) {
      // if(payload.token)
      return {
        ...state,
        loggedInUser: { ...state.loggedInUser, token: payload.token },
      };
    },
    setBreadcrumb(state, { payload }) {
      return {
        ...state,
        breadCrumb: payload.links,
      };
    },
    setPageTitle(state, { payload }) {
      // alert("SETTING TITLE " + state.projectId + " TITLE " + payload.title);
      if (state.projectId && payload.removeProject !== true) {
        payload.title
          ? state.projectTitle
            ? setDocumentTitle(state.projectTitle + " :: " + payload.title)
            : setDocumentTitle(payload.title)
          : setDocumentTitle(state.projectTitle);
      } else {
        setDocumentTitle(payload.title);
      }

      return {
        ...state,
        pageTitle: payload.title,
      };
    },
    setModalOpen(state, { payload }) {
      return {
        ...state,
        isModal: payload.isModal,
      };
    },
    setPageTitleHTML(state, { payload }) {
      return {
        ...state,
        pageTitleHTML: payload.html,
      };
    },
    setPlanDetails(state, { payload }) {
      return {
        ...state,
        planDetails: payload,
      };
    },
    updateCompanyDetails(state, { payload }) {
      const nextPatch = { ...payload };
      const rawIsOnboarded = Object.prototype.hasOwnProperty.call(
        payload,
        "is_onboarded"
      )
        ? payload.is_onboarded
        : Object.prototype.hasOwnProperty.call(payload, "isOnboarded")
        ? payload.isOnboarded
        : undefined;
      if (rawIsOnboarded !== undefined) {
        nextPatch.is_onboarded = coerceBooleanFlag(rawIsOnboarded);
      }
      if (Object.prototype.hasOwnProperty.call(payload, "onboarding_info")) {
        nextPatch.onboarding_info = normalizeOnboardingInfo(
          payload.onboarding_info
        );
      }
      return {
        ...state,
        company: { ...state.company, ...nextPatch },
      };
    },
    setProjectSettingsByKey(state, { payload }) {
      return {
        ...state,
        projectSettingsByKey: applyAiOptOutToProjectSettings(
          { ...state.projectSettingsByKey, ...payload },
          state.company
        ), // TCV-6854
      };
    },
    setProjectDetails(state, { payload }) {
      console.log(
        "DEBUG: AppModel - setProjectDetails reducer payload:",
        payload
      ); // Added log
      const incoming = _.get(payload, "projectId");
      const current = _.get(state, "projectId");

      let projectTags = []; // Initialize to empty array
      if (incoming !== current && incoming) {
        // try {
        //   if (userflow != undefined) {
        //     if (userflow.isIdentified()) {
        //       // User is identified. Add projectId
        //       userflow.updateUser({ projectId: incoming });
        //     }
        //   }
        // } catch (e) {
        //   console.log({ userflow_error: e });
        // }
        if (current) projectTags = payload.projectTags || []; // Ensure it's an array
      }
      projectTags = payload.projectTags || []; // Ensure it's an array

      const hasProjectCount = Object.prototype.hasOwnProperty.call(
        payload,
        "projectTestCaseCount"
      );
      const projectTestCaseCount = hasProjectCount
        ? payload.projectTestCaseCount
        : payload.projectId
        ? state.projectTestCaseCount
        : null;

      return {
        ...state,
        projectId: payload.projectId,
        projectTestCaseCount,
        projectTitle: payload.projectTitle,
        projectArchived: payload.projectArchived || false,
        projectMembers: payload.projectMembers,
        projectSettingsByKey: applyAiOptOutToProjectSettings(
          payload.projectSettingsByKey || state.projectSettingsByKey,
          state.company
        ), // TCV-6854
        defectsEnabled:
          payload.defectsEnabled != undefined ? payload.defectsEnabled : false,
        requirementsEnabled:
          payload.requirementsEnabled != undefined
            ? payload.requirementsEnabled
            : state.requirementsEnabled
            ? state.requirementsEnabled
            : false,
        projectTags,
        projectUsers: payload.projectUsers,
        projectStatuses: payload.projectStatuses || [], // Added projectStatuses
      };
    },
    setProjectStatuses(state, { payload }) {
      // Added reducer
      return {
        ...state,
        projectStatuses: payload.statuses,
      };
    },
    setProjectTestCaseCount(state, { payload }) {
      return {
        ...state,
        projectTestCaseCount: payload.count,
      };
    },
    setProjectLock(state, { payload }) {
      return {
        ...state,
        projectLock: { ...state.projectLock, ...payload },
      };
    },
    setOnlineUsers(state, { payload }) {
      return {
        ...state,
        onlineUsers: payload.onlineUsers,
      };
    },
    setSystemStatus(state, { payload }) {
      return {
        ...state,
        online: payload.status != false,
      };
    },
    setUpgradeModal(state, { payload }) {
      return {
        ...state,
        featureModal: payload,
      };
    },
    setUsers(state, { payload }) {
      //if (state.projectId != payload.projectId) {

      const _ = require("lodash");
      const userIndex = _.keyBy(payload.users, "id");

      return {
        ...state,
        users: payload.users,
        userIndex: userIndex,
      };
    },
    setReady(state, { payload }) {
      return {
        ...state,
        ready: payload.ready,
      };
    },
    setProjects(state, { payload }) {
      let projects = payload.projects;
      // payload.projects.forEach((project) => {
      //   projects.push(project.Project);
      // });
      return {
        ...state,
        projects,
      };
    },
    setConfig(state, { payload }) {
      return {
        ...state,
        config: payload.config,
      };
    },
    setCompany(state, { payload }) {
      const { settings } = payload.company;
      let hasActivePlan = false;
      const previousCompanyId = _.get(state, "company.id");
      const incomingCompanyId = _.get(payload, "company.id");
      const shouldResetQualification =
        incomingCompanyId && incomingCompanyId !== previousCompanyId;
      // adding payload.company.plan != "free" condition to disable free plan and show upgrade
      if (payload.company.plan && payload.company.plan != "free") {
        // Possible values are incomplete, trialing, active, past_due, incomplete_expired, canceled, or unpaid.

        if (
          payload.company.planStatus === "active" ||
          payload.company.planStatus === "trialing" ||
          payload.company.planStatus === "past_due" ||
          payload.company.planStatus === "incomplete"
        ) {
          if (
            payload.company.trialDetails &&
            payload.company.trialDetails.isActive
          ) {
            try {
              hasActivePlan = moment
                .unix(payload.company.trialDetails.expiration)
                .isAfter(new Date());
            } catch (error) {
              console.log({ setCompany_error: error });
            }
          } else {
            hasActivePlan = true;
          }
        }
      }

      payload.company.hasActivePlan = hasActivePlan;
      if (settings && Array.isArray(settings) && settings.length) {
        const timeZoneSetting = _.find(settings, { name: "timezone" });
        if (timeZoneSetting) {
          // console.log({ "setting timezone to ": timeZoneSetting });
          moment.tz.setDefault(timeZoneSetting.value);
          window["TIMEZONE"] = timeZoneSetting.value;
        }
      }
      const rawIsOnboarded = _.get(payload, "company.is_onboarded");
      const rawIsOnboardedCamel = _.get(payload, "company.isOnboarded");
      payload.company.is_onboarded = coerceBooleanFlag(
        rawIsOnboarded !== undefined ? rawIsOnboarded : rawIsOnboardedCamel
      );
      payload.company.onboarding_info = normalizeOnboardingInfo(
        _.get(payload, "company.onboarding_info") ??
          _.get(payload, "company.onboardingInfo")
      );

      const prev = _.lowerCase(_.get(state, "company.plan"));
      const current = _.lowerCase(_.get(payload, "company.plan"));
      if (prev === "free" && current && current !== prev) {
        // Plan upgraded, send userflow event
        // try {
        //   if (
        //     process.env.USERFLOW_TOKEN &&
        //     userflow != undefined &&
        //     !inIframe()
        //   ) {
        //     if (!userflow.isIdentified()) {
        //       userflow.init(process.env.USERFLOW_TOKEN);
        //     }
        //     if (!userflow.isIdentified()) {
        //       userflow.track("plan_upgraded", {
        //         plan: current
        //       });
        //     }
        //   }
        // } catch (e) {
        //   console.log({ userflow_error: e });
        // }
      }

      // debugger;
      return {
        ...state,
        company: payload.company,
        // TCV-6854: re-derive so toggling the opt-out takes effect immediately.
        enabledFeatures: applyAiOptOut(
          state.enabledFeaturesRaw,
          payload.company
        ),
        isCompanyQualified: shouldResetQualification
          ? null
          : state.isCompanyQualified,
      };
    },
    setCompanyUsers(state, { payload }) {
      return {
        ...state,
        companyUsers: payload.users,
      };
    },
    setCompanyQualification(state, { payload }) {
      if (
        !payload ||
        !Object.prototype.hasOwnProperty.call(payload, "isQualified")
      ) {
        return state;
      }
      if (payload.isQualified === null) {
        return {
          ...state,
          isCompanyQualified: null,
        };
      }
      if (typeof payload.isQualified === "boolean") {
        return {
          ...state,
          isCompanyQualified: payload.isQualified,
        };
      }
      return state;
    },
    setCompanies(state, { payload }) {
      return {
        ...state,
        companies: payload.companies,
      };
    },
    setDefectEnabled(state, { payload }) {
      return {
        ...state,
        defectsEnabled: payload.isEnabled,
      };
    },
    setRequirementEnabled(state, { payload }) {
      return {
        ...state,
        requirementsEnabled: payload.isEnabled,
      };
    },
    updateProjectSettings(state, { payload }) {
      return {
        ...state,
        projectSettingsByKey: applyAiOptOutToProjectSettings(
          { ...state.projectSettingsByKey, ...payload },
          state.company
        ), // TCV-6854
      };
    },
    setSsoInfo(state, { payload }) {
      return {
        ...state,
        ssoInfo: payload.ssoInfo,
      };
    },
    setEnabledFeatures(state, { payload }) {
      return {
        ...state,
        enabledFeaturesRaw: payload.enabledFeatures, // TCV-6854
        enabledFeatures: applyAiOptOut(payload.enabledFeatures, state.company),
      };
    },
    setCopilotUser(state, { payload }) {
      return {
        ...state,
        copilotUser: payload.copilotUser,
      };
    },
    setProjectMembers(state, { payload }) {
      return {
        ...state,
        projectMembers: payload.members,
      };
    },
    setProjectUsers(state, { payload }) {
      return {
        ...state,
        projectUsers: payload.users,
      };
    },
    setCompanyProjectStatuses(state, { payload }) {
      return {
        ...state,
        companyProjectStatuses: payload.statusesList,
      };
    },
    // setProjectTags(state, { payload }) { // Commented out again
    //   return {
    //     ...state,
    //     projectTags: payload.tags
    //   };
    // },
    setLoggedInUserNotificationPreferences(state, { payload }) {
      return {
        ...state,
        loggedInUser: {
          ...state.loggedInUser,
          preferences: {
            ...state.loggedInUser.preferenes,
            notification: payload.preferences,
          },
        },
      };
    },
    setLastAccessedProjects(state, { payload }) {
      return {
        ...state,
        loggedInUser: {
          ...state.loggedInUser,
          preferences: {
            ...state.loggedInUser.preferences,
            lastAccessedProjects: payload.lastAccessedProjects,
          },
        },
      };
    },
  },
  effects: {
    *fetchCompanyQualification({ payload }, { call, put, select }) {
      const companyId =
        _.get(payload, "companyId") ||
        _.get(payload, "company") ||
        (yield select((state) => _.get(state, "app.company.id")));

      if (!companyId) {
        return;
      }

      try {
        const companiesApi = new CompaniesApi();
        const response = yield call(
          [companiesApi, companiesApi.getCompanyQualification],
          { id: companyId }
        );
        const isQualified = _.get(response, "isQualified", null);
        yield put({
          type: "setCompanyQualification",
          payload: {
            isQualified: typeof isQualified === "boolean" ? isQualified : null,
          },
        });
      } catch (e) {
        console.error("Error fetching company qualification:", e);
      }
    },
    *fetchProjectStatuses({ payload }, { call, put, select }) {
      // Added effect
      const projectId = yield select((state) => state.app.projectId);
      if (!projectId) {
        return;
      }
      try {
        const statusesApi = new StatusesApi();
        const statuses = yield call([statusesApi, statusesApi.getStatuses], {
          project: projectId,
          isActive: true,
        });
        yield put({
          type: "app/setProjectStatuses",
          payload: { statuses },
        });
      } catch (e) {
        console.error("Error fetching project statuses:", e);
      }
    },
    *fetchCompanyProjectStatuses({ payload }, { call, put, select }) {
      console.info("Fetching company project statuses...");
      const companyId = yield select((state) => state.app.company.id);
      if (!companyId) {
        return;
      }
      let statusesList = {};
      try {
        const companiesApi = new CompaniesApi();
        const companyWiseCaseStatuses = yield call(
          [companiesApi, companiesApi.getCompanyWiseCaseStatuses],
          {
            company: companyId,
          }
        );
        if (companyWiseCaseStatuses && companyWiseCaseStatuses.length) {
          companyWiseCaseStatuses.forEach((item) => {
            statusesList[item.project.toString()] = item.statuses;
          });
        }
      } catch (e) {
        console.error("Error fetching company project statuses:", e);
      }
      yield put({
        type: "app/setCompanyProjectStatuses",
        payload: { statusesList },
      });
    },
    *fetchProjectTestCaseCount({ payload }, { call, put, select }) {
      try {
        const projectId =
          payload && payload.projectId
            ? payload.projectId
            : yield select((state) => state.app.projectId);
        if (!projectId) {
          return;
        }
        const api = new TestCasesApi();
        const countResult = yield call([api, api.getTestCaseCount], {
          project: Number(projectId),
        });
        const count = _.get(countResult, "count", 0);
        yield put({
          type: "app/setProjectTestCaseCount",
          payload: { count },
        });
      } catch (e) {
        console.error("Error fetching project test case count:", e);
      }
    },
    *initializeProjectLockState({ payload }, { put }) {
      const { userId } = payload || {};
      if (!userId) {
        yield put({
          type: "app/setProjectLock",
          payload: { trackedProjectId: null, dismissed: false },
        });
        return;
      }
      let stored = null;
      try {
        stored = Storage.get(`PROJECT_LOCK_STATE_${userId}`);
      } catch (e) {
        stored = null;
      }
      if (typeof stored === "string") {
        try {
          stored = JSON.parse(stored);
        } catch (e) {
          stored = null;
        }
      }
      if (!stored || typeof stored !== "object") {
        stored = { trackedProjectId: null, dismissed: false };
      }
      if (stored.trackedProjectId !== null) {
        stored.trackedProjectId = Number(stored.trackedProjectId);
      }
      stored.dismissed = !!stored.dismissed;
      yield put({
        type: "app/setProjectLock",
        payload: stored,
      });
    },
    *updateProjectLockState({ payload }, { call, put, select }) {
      const current = yield select((state) => state.app.projectLock || {});
      const userId = yield select((state) =>
        _.get(state, "app.loggedInUser.id")
      );
      const nextState = {
        ...current,
        ...payload,
      };
      if (
        nextState.trackedProjectId !== null &&
        nextState.trackedProjectId !== undefined
      ) {
        nextState.trackedProjectId = Number(nextState.trackedProjectId);
      } else {
        nextState.trackedProjectId = null;
      }
      nextState.dismissed = !!nextState.dismissed;
      yield put({
        type: "app/setProjectLock",
        payload: nextState,
      });
      if (userId) {
        try {
          Storage.set(`PROJECT_LOCK_STATE_${userId}`, nextState);
        } catch (e) {
          console.warn("Unable to persist project lock state", e);
        }
      }
    },
    *ensureProjectLockTracked({ payload }, { select, put }) {
      const projectId = _.get(payload, "projectId");
      if (!projectId) {
        return;
      }
      const lockState = yield select((state) => state.app.projectLock || {});
      if (lockState.dismissed) {
        return;
      }
      if (
        lockState.trackedProjectId &&
        Number(lockState.trackedProjectId) !== Number(projectId)
      ) {
        return;
      }
      if (!lockState.trackedProjectId) {
        yield put({
          type: "app/updateProjectLockState",
          payload: { trackedProjectId: Number(projectId) },
        });
      }
    },
    *dismissProjectLock({ payload }, { select, put, call }) {
      const { skipPersist = false } = payload || {};
      const lockState = yield select((state) => state.app.projectLock || {});
      if (lockState.dismissed) {
        return;
      }
      yield put({
        type: "app/updateProjectLockState",
        payload: { dismissed: true, trackedProjectId: null },
      });

      if (!skipPersist) {
        const companyId = yield select((state) =>
          _.get(state, "app.company.id")
        );
        if (companyId) {
          try {
            const settingsAPI = new SettingsApi();
            yield call([settingsAPI, settingsAPI.setSettings], {
              settingPayload: {
                company: companyId,
                settingType: "general",
                settings: [
                  {
                    name: "onboarding_project_lock_dismissed",
                    value: "1",
                    label: "Onboarding project lock dismissed",
                    settingType: "general",
                    company: companyId,
                  },
                ],
              },
            });
            const existingSettings = yield select((state) =>
              _.get(state, "app.company.settings", [])
            );
            const updatedSettings = Array.isArray(existingSettings)
              ? [
                  ...existingSettings.filter(
                    (st) =>
                      st && st.name !== "onboarding_project_lock_dismissed"
                  ),
                  {
                    name: "onboarding_project_lock_dismissed",
                    value: "1",
                    label: "Onboarding project lock dismissed",
                    setting_type: "general",
                    company: companyId,
                  },
                ]
              : [
                  {
                    name: "onboarding_project_lock_dismissed",
                    value: "1",
                    label: "Onboarding project lock dismissed",
                    setting_type: "general",
                    company: companyId,
                  },
                ];
            yield put({
              type: "app/updateCompanyDetails",
              payload: {
                settings: updatedSettings,
              },
            });
          } catch (e) {
            console.warn("Failed to persist onboarding lock dismissal", e);
          }
        }
      }
    },
    *fetchProjectSettings({ payload }, { call, put, select }) {
      console.info("Fetching project settings...");

      //return;

      const projectId = getProjectId(document.location.pathname);

      if (!projectId) {
        return;
      }
      yield put({
        type: "setReady",
        payload: { ready: false },
      });

      // is it same project as last state?
      yield put({
        type: "fetchProjectInfo",
        payload: { projectId },
      });

      // fetch project members
      yield put({
        type: "fetchProjectUsers",
        payload: { projectId },
      });

      yield put({
        type: "setReady",
        payload: { ready: true },
      });
    },
    *updateUserDetails(
      { payload: { user, storeSession = false, remember = false } },
      { call, put, select }
    ) {
      const api = new UsersApi();
      const getFullUser = async () => {
        try {
          const userFull = await api.getMyUser();
          return userFull;
        } catch (e) {
          console.log({ getUser_error: e });
          // handleError(e.status);
          // console.error("Unable to fetch companies!!!");
        }
      };
      const userFull = yield call(getFullUser);

      yield put({
        type: "setLoggedInUser",
        payload: {
          user: { ...userFull },
        },
      });
    },
    *updatePlanDetails_v2(
      { payload: { company, planDetails } },
      { call, put, select }
    ) {
      /*
      const fetchPlanDetails = async () => {
        try {
          const companyAPI = new CompaniesApi();
          const plan = await companyAPI.getCompanyPlan({ id: company });
          // console.log({ userFull });

          return plan;
        } catch (e) {
          handleError(e.status);
          return [];
          console.error("Unable to fetch companies!!!");
        }
      };
      */
      //const planDetails = yield call(fetchPlanDetails, company);
      yield put({
        type: "setPlanDetails",
        payload: planDetails,
      });
    },
    *updatePlanDetails({ payload: { company } }, { call, put, select }) {
      const fetchPlanDetails = async () => {
        try {
          const companyAPI = new CompaniesApi();
          const plan = await companyAPI.getCompanyPlan({ id: company });
          // console.log({ userFull });

          return plan;
        } catch (e) {
          handleError(e.status);
          return [];
          console.error("Unable to fetch companies!!!");
        }
      };
      const planDetails = yield call(fetchPlanDetails, company);
      yield put({
        type: "setPlanDetails",
        payload: planDetails,
      });
    },
    *updateUsageDetails({ payload: { company } }, { call, put, select }) {
      const fetchUsageDetails = async () => {
        try {
          const usersApi = new UsersApi();
          const companyAPI = new CompaniesApi();
          const promises = [
            usersApi.getUsersCount({
              company: company,
              filter: JSON.stringify({
                // confirmed: 1,
                is_copilot: 0,
              }),
            }),
            companyAPI.getCompany({ id: company }),
          ];
          const results = await Promise.all(promises);
          const totalConfirmedUsers = results[0];
          const details = results[1];
          // let totalConfirmedUsers = await usersApi.getUsersCount({
          //   company: company,
          //   filter: JSON.stringify({
          //     // confirmed: 1,
          //     is_copilot: 0,
          //   }),
          // });
          // const details = await companyAPI.getCompany({ id: company });
          //@todo Throw error maybe if not fetched usage details
          return details
            ? {
                ...details["usageDetails"],
                users:
                  totalConfirmedUsers && totalConfirmedUsers["count"]
                    ? totalConfirmedUsers["count"]
                    : 1,
              }
            : {};
        } catch (e) {
          handleError(e.status);
          return [];
          console.error("Unable to fetch companies!!!");
        }
      };
      const usageDetails = yield call(fetchUsageDetails, company);
      yield put({
        type: "updateCompanyDetails",
        payload: {
          usageDetails,
        },
      });
      /*
      yield put({
        type: "fetchCompanyQualification",
        payload: { companyId: company },
      });*/
    },
    *afterLogin(
      {
        payload: {
          user,
          init = false,
          storeSession = false,
          remember = false,
          callback = function (loggedIn) {},
        },
      },
      { call, put, select, all }
    ) {
      if (storeSession) {
        let expiry = 0;
        if (remember) {
          expiry = 14 * 24 * 60; // 14 days in minutes
        }
        storeUserSession(user, expiry);
      }

      window["JWT"] = user.jwt;

      // Refresh session TTL every hour so "Remember Me" sessions
      // don't expire while the tab is open
      if (window._sessionTTLInterval) clearInterval(window._sessionTTLInterval);
      window._sessionTTLInterval = setInterval(
        refreshSessionTTL,
        60 * 60 * 1000
      );

      setAuthGlobals({
        jwt: user.jwt,
      });

      // fetch user companies
      // console.info("Fetching companies...");
      const getFeatureStatus = async (featureName = null) => {
        try {
          let featureResult = await fetchFeatureStatus(
            featureName ? featureName : "qa_copilot"
          );
          // localStorage.setItem(`feature-${featureName ? featureName : "qa_copilot"}`, featureResult ? "1" : "0");
          return featureResult;
        } catch (e) {
          console.log({ getFeatureStatus_error: e });
        }
        return false;
      };

      const api = new UsersApi();
      const getCompanies = async () => {
        try {
          const userFull = await api.getMyUser();
          return userFull;
        } catch (e) {
          // handleError(e.status);
          console.error("Unable to fetch companies!");
        }
      };

      const fetchProjects = async (company) => {
        try {
          const projectAPI = new ProjectsApi();
          const projects = await projectAPI.getProjects({ company, limit: -1 });
          return projects;
        } catch (e) {
          handleError(e.status);
          return [];
          console.error("Unable to fetch companies!!!");
        }
      };
      const fetchRecentProjects = async (company, userId) => {
        try {
          const projectAPI = new ProjectsApi();
          const projects = await projectAPI.getProjects({
            company,
            limit: 5,
            sort: "activity:desc",
            filter: JSON.stringify({ "team.user": userId }),
          });
          return projects;
        } catch (e) {
          // handleError(e.status);
          return [];
        }
      };
      const fetchPaymentProfile = async (company) => {
        try {
          const api = new SaasOnlyApi();
          const profiles = await api.getPaymentProfiles({ company });
          return _.head(profiles);
        } catch (e) {
          handleError(e.status);
          return null;
          console.error("Unable to fetch companies!!!");
        }
      };
      const fetchSettings = async (company) => {
        try {
          const settingsAPI = new SettingsApi();
          const settings = await settingsAPI.getSettings({ company });
          //console.log({ settings })
          //debugger;
          return settings;
        } catch (e) {
          handleError(e.status);
          return [];
          console.error("Unable to fetch companies!!!");
        }
      };

      const getUsers = async (company) => {
        try {
          const users = await api.getUsers({ company });
          return users;
        } catch (e) {
          handleError(e.status);
          console.error("Unable to fetch company users!!!");
          return [];
        }
      };

      const fetchCompanyStats = async (company) => {
        try {
          const companyAPI = new CompaniesApi();
          const compStats = await companyAPI.getCompany({
            id: company,
            includeStats: true,
          });
          return compStats;
        } catch (e) {
          handleError(e.status);
          return {};
          console.error("Unable to fetch companies!!!");
        }
      };

      const fetchPlanDetails = async (company) => {
        try {
          const companyAPI = new CompaniesApi();
          const plan = await companyAPI.getCompanyPlan({ id: company });
          //console.log({ plan })
          // console.log({ userFull });

          return plan;
        } catch (e) {
          handleError(e.status);
          return [];
          console.error("Unable to fetch companies!!!");
        }
      };

      const fetchCompanyProjectStatuses = async (company) => {
        let statusesList = {};
        try {
          const companiesApi = new CompaniesApi();
          const companyWiseCaseStatuses =
            await companiesApi.getCompanyWiseCaseStatuses({
              company: company,
            });
          if (companyWiseCaseStatuses && companyWiseCaseStatuses.length) {
            companyWiseCaseStatuses.forEach((item) => {
              statusesList[item.project.toString()] = item.statuses;
            });
          }
          return statusesList;
        } catch (e) {
          console.error("Error fetching company project statuses:", e);
        }
        return statusesList;
      };

      let companyData = null;
      let users = null;
      let projects = null;
      let settings = null;
      let paymentProfile = null;
      let companyProjectStatuses = null;
      let primaryCompanyId = null;
      try {
        let userFull = yield call(getCompanies);
        // console.log({ userFull });
        let companyStats = null;
        if (userFull) {
          const { companies } = userFull;
          if (
            !init &&
            !userFull.name &&
            !(companies && companies.length) &&
            !location.pathname.includes("company_setup")
          ) {
            location.pathname = "/company_setup";
          }

          if (
            !(companies && companies.length) &&
            !location.pathname.includes("company_setup")
          ) {
            location.pathname = "/company_setup";
          }

          yield put({
            type: "setCompanies",
            payload: {
              companies: companies,
            },
          });
          let recentProjectsData = [];
          if (companies && companies.length == 1) {
            const company = companies[0];
            primaryCompanyId = company["id"];
            companyData = companies[0];
            /*
            let featureResult = yield call(getFeatureStatus);
            let bulkAutomateFeatureResult = yield call(
              getFeatureStatus,
              "qa_copilot_bulk_automation"
            );*/
            const [
              featureResult,
              bulkAutomateFeatureResult,
              testDatasetFeatureResult,
              disableFreePlanFeatureResult,
              linkedRepoSyncFeatureResult,
              releaseReadinessFeatureResult,
              projectSecretsFeatureResult,
              xrayImportFeatureResult,
              buildsFeatureResult,
              entraSsoFeatureResult,
            ] = yield all([
              call(getFeatureStatus),
              call(getFeatureStatus, "qa_copilot_bulk_automation"),
              call(getFeatureStatus, "test_datasets"),
              call(getFeatureStatus, "disable_free_plan"),
              call(getFeatureStatus, "linked_repo_sync"),
              call(getFeatureStatus, "release_readiness_dashboard"),
              call(getFeatureStatus, "project_secrets"),
              call(getFeatureStatus, "xray_import"),
              call(getFeatureStatus, "builds"),
              call(getFeatureStatus, "entra_sso"),
            ]);

            let enabledFeaturesPayload = [];
            if (featureResult) {
              enabledFeaturesPayload.push("qa_copilot");
              companyData.qacFeatureEnabled = true;
            }
            if (bulkAutomateFeatureResult) {
              enabledFeaturesPayload.push("qa_copilot_bulk_automation");
            }
            if (testDatasetFeatureResult) {
              enabledFeaturesPayload.push("test_datasets");
            }
            if (disableFreePlanFeatureResult) {
              enabledFeaturesPayload.push("disable_free_plan");
            }
            if (linkedRepoSyncFeatureResult) {
              enabledFeaturesPayload.push("linked_repo_sync");
            }
            if (releaseReadinessFeatureResult) {
              enabledFeaturesPayload.push("release_readiness_dashboard");
            }
            if (projectSecretsFeatureResult) {
              enabledFeaturesPayload.push("project_secrets");
            }
            if (xrayImportFeatureResult) {
              enabledFeaturesPayload.push("xray_import");
            }
            if (buildsFeatureResult) {
              enabledFeaturesPayload.push("builds");
            }
            if (entraSsoFeatureResult) {
              enabledFeaturesPayload.push("entra_sso");
            }
            yield put({
              type: "setEnabledFeatures",
              payload: {
                enabledFeatures: enabledFeaturesPayload,
              },
            });

            //users = yield call(getUsers, company["id"]);

            /*
            users = yield call(getUsers, company["id"]);

            projects = yield call(fetchProjects, company["id"]);
            settings = yield call(fetchSettings, company["id"]);
            paymentProfile = yield call(fetchPaymentProfile, company["id"]);
            companyStats = yield call(fetchCompanyStats, company["id"]);*/
            //const planDetails = yield call(fetchPlanDetails, company);
            // TCV-6531: Guest users (public dashboard share) lack access to
            // company-wide project lists. Skip those fetches to avoid 401s
            // that surface as a "You are not authorized" toast.
            const isGuestUser = _.get(userFull, "isGuest") === true;
            const [
              users,
              projects,
              settings,
              paymentProfile,
              companyStats,
              planDetails,
              recentProjects,
              companyProjectStatusesData,
            ] = yield all([
              call(getUsers, company["id"]),
              isGuestUser ? call(() => []) : call(fetchProjects, company["id"]),
              call(fetchSettings, company["id"]),
              call(fetchPaymentProfile, company["id"]),
              call(fetchCompanyStats, company["id"]),
              call(fetchPlanDetails, company["id"]),
              isGuestUser
                ? call(() => [])
                : call(fetchRecentProjects, company["id"], userFull["id"]),
              call(fetchCompanyProjectStatuses, company["id"]),
            ]);
            recentProjectsData = recentProjects;
            companyProjectStatuses = companyProjectStatusesData;
            // const planDetails = yield call(fetchPlanDetails, company["id"]);
            company.settings = settings;

            const lockSetting = _.find(settings, {
              name: "onboarding_project_lock_dismissed",
            });
            const lockSettingValue = _.get(lockSetting, "value");
            const lockDismissedFromSetting =
              lockSettingValue === 1 ||
              lockSettingValue === "1" ||
              lockSettingValue === true ||
              lockSettingValue === "true";

            const companyCreatedAtRaw =
              _.get(company, "created_at") ||
              _.get(company, "createdAt") ||
              _.get(companyData, "created_at") ||
              _.get(companyData, "createdAt");
            let createdBeforeCutoff = false;
            if (companyCreatedAtRaw) {
              const createdMoment = moment(companyCreatedAtRaw);
              if (
                createdMoment.isValid() &&
                createdMoment.isBefore(moment("2025-10-06"))
              ) {
                createdBeforeCutoff = true;
              }
            }

            if (lockDismissedFromSetting || createdBeforeCutoff) {
              yield put({
                type: "app/dismissProjectLock",
                payload: { skipPersist: lockDismissedFromSetting },
              });
            }

            if (companyStats.stats) {
              companyData.stats =
                typeof companyStats.stats === "string"
                  ? JSON.parse(companyStats.stats)
                  : companyStats.stats;
            }
            if (
              companyStats &&
              companyStats.usageDetails &&
              companyStats.usageDetails.users
            ) {
              companyData.usageDetails.users = companyStats.usageDetails.users;
            }
            let copilotUser = null;
            if (users && users.length) {
              copilotUser = _.find(users, { isCopilot: true });
            }
            companyData.planDetails = planDetails;
            companyData.copilotUser = copilotUser;

            yield put({
              type: "updatePlanDetails_v2",
              payload: { company: company["id"], planDetails },
            });

            yield put({
              type: "setCompanyUsers",
              payload: { users },
            });
            yield put({
              type: "setCopilotUser",
              payload: { copilotUser },
            });

            yield put({
              type: "setCompany",
              payload: {
                company: {
                  ...company,
                  paymentProfile,
                  stats: companyStats.stats,
                },
              },
            });

            yield put({
              type: "setProjects",
              payload: { projects },
            });
          }

          yield put({
            type: "setCompanyProjectStatuses",
            payload: { statusesList: companyProjectStatuses },
          });

          const activeCompanyId =
            primaryCompanyId ||
            _.get(companyData, "id") ||
            _.get(userFull, "companies[0].id");
          if (activeCompanyId) {
            /*
            yield put({
              type: "fetchCompanyQualification",
              payload: { companyId: activeCompanyId },
            });*/
          }

          yield put({
            type: "setLoggedInUser",
            payload: {
              user: {
                ...user.user,
                name: userFull.name,
                rank: userFull.rank,
                avatar: userFull.avatar,
                preferences: {
                  ...userFull.preferences,
                  lastAccessedProjects: recentProjectsData,
                },
                aboutMe: userFull.aboutMe,
                createdAt: userFull.createdAt,
                token: _.get(userFull, "token.token"),
                isGuest: _.get(userFull, "isGuest"),
                isCopilot: _.get(userFull, "isCopilot"),
              },
            },
          });
          yield put({
            type: "app/initializeProjectLockState",
            payload: { userId: _.get(userFull, "id") },
          });
          if (callback && typeof callback === "function") {
            callback(userFull);
          }
        } else {
          // yield call(delay, 500);
          if (callback && typeof callback === "function") {
            callback(false);
          }
        }
        yield put({
          type: "fetchProjectSettings",
        });

        yield put({
          type: "fetchUsers",
        });

        // yield put({
        //   type: "fetchSaaSInstance"
        // });

        // TCV-6856: user & company identifiers are deliberately not sent to
        // Sentry — error details only.

        if (
          process.env.NODE_ENV == "production" ||
          process.env.REACT_APP_ENABLE_INTERCOM === "true"
        ) {
          //if (CustomEvent) {
          // const event = new CustomEvent("onUserLogin", {
          //   //detail: { user: userFull }
          // });
          //window.dispatchEvent(event);
          //}
          if (userFull && !userFull.isGuest) {
            let icSettings = getIntercomSettings(userFull, {
              ...companyData,
              ...{ paymentProfile },
            });
            //console.log({icSettings});

            window["intercomSettings"] = icSettings;

            try {
              if (window["Intercom"] != undefined) {
                window["Intercom"]("boot", window["intercomSettings"]);
              }
            } catch (e) {
              console.log({ Intercom_error: e });
            }
          }
          // try {
          //   if (
          //     process.env.USERFLOW_TOKEN &&
          //     userflow != undefined &&
          //     !inIframe()
          //   ) {
          //     userflow.init(process.env.USERFLOW_TOKEN);
          //     userflow
          //       .identify(_.get(userFull, "id"), {
          //         name: _.get(userFull, "name"),
          //         company: _.get(companyData, "name"),
          //         plan: _.get(companyData, "plan"),
          //         rank: _.get(userFull, "rank"),
          //         isSuperAdmin:
          //           _.get(companyData, "owner.id") === _.get(userFull, "id"),
          //         signed_up_at: _.get(userFull, "createdAt")
          //       })
          //       .then(() => console.log("DONE....."))
          //       .catch(e => console.log("USERFLOW ERROR", e));
          //     console.log("Initialized successfully...");
          //   } else {
          //     console.log("User flow token not available!");
          //   }
          // } catch (error) {
          //   console.log({ error });
          // }
          try {
            let canLoadFullstory = true;
            // if (userFull && userFull.createdAt) {
            //   if (moment().diff(moment(userFull.createdAt), "days") > 90) {
            //     canLoadFullstory = false;
            //   }
            // }
            if (canLoadFullstory) {
              LoadFullstory(() => {
                if (window["FS"] != undefined) {
                  window["FS"].restart();
                  window["FS"].identify(_.get(userFull, "id"), {
                    displayName: _.get(userFull, "name"),
                    email: _.get(userFull, "email"),
                    user_id: _.get(userFull, "id"),
                    reviewsWritten_int: 14,
                  });
                }
              });
            }
          } catch (e) {
            console.log({ fullstory_error: e });
          }
        }
        trackEvent("Login", null);
      } catch (error) {
        if (callback && typeof callback === "function") {
          callback(false);
        }
      }
    },
    *checkIfSessionExists({ payload }, { call, put, select }) {
      let user = false;
      try {
        //debugger;
        let raw = Storage.get("TC_USER");
        if (typeof raw == "object") {
          user = raw;
        }

        if (typeof raw == "string") {
          user = yield JSON.parse(raw);
        }
      } catch {
        if (payload.callback) payload.callback(false);
        return;
      }

      if (user) {
        //setAuthGlobals({ apiKey: user.api_key });

        // Keep the stored session alive while the user is active
        refreshSessionTTL();

        yield put({
          type: "afterLogin",
          payload: {
            user: user,
            ...payload,
          },
        });
      } else {
        if (payload.callback) payload.callback(false);
      }
    },

    *setLastAccessedProjects({ payload }, { call, put, select }) {
      const userPrefs = yield select(
        (state) => state.app.loggedInUser.preferences
      );
      if (typeof userPrefs == "object") {
        // const sortedProjects = _.sortBy(userPrefs.lastAccessedProjects, [
        //   "last_accessed"
        // ]);
      }
    },

    *login(
      { payload: { email, password, remember, callback } },
      { call, put, select }
    ) {
      // console.info("Calling server login..");

      // const realApi = new Configuration({
      //   basePath: "http://localhost/api/v2"
      // });
      const api = new UsersApi();

      const login = async (loginPayload) => {
        try {
          return await api.login({ userLoginPayload: loginPayload });
        } catch (e) {
          if (e.json) {
            e.json().then((data) => {
              if (data.statusCode === 400) {
                if (
                  data.message &&
                  data.message.indexOf("reset password link")
                ) {
                  return notification.error({
                    message: data.message,
                  });
                }
                return notification.error({
                  message: "Email or password invalid.",
                });
              }
              handleError(data.statusCode, {}, data.message || "");
            });
          } else {
            console.log({ login_error: e });
            notification.warn({
              message:
                e && e.message
                  ? e.message
                  : "Could not process your request at the moment. Please try again.",
            });
          }
          if (callback) callback();
        }
      };
      const user = yield call(login, {
        identifier: email,
        password,
      });
      // const user = yield call(login, {
      //   identifier: "abhi@testcollab.com",
      //   password: "longpassword"
      // });
      if (user && user.jwt) {
        yield put({
          type: "afterLogin",
          payload: {
            user: user,
            storeSession: true,
            remember: remember,
            callback,
          },
        });

        // let expiry = 0;
        // if (remember) {
        //   expiry = 14 * 24 * 60; // 14 days in minutes
        // }
        //storeUserSession(user, expiry);

        // loggedInSuccessMsg(user);
      }
    },

    *logout({ payload }, { call, put, select }) {
      console.info("Logging out user...");
      const forceLogout = _.get(payload, "forceLogout");
      const type = _.get(payload, "type");
      window["jwt"] = "";
      const api = new UsersApi();
      const logout = async () => {
        try {
          return await api.logout();
        } catch (e) {
          if (!forceLogout) {
            if (e.json) {
              e.json().then((data) => {
                if (data.statusCode === 400) {
                  return notification.error({
                    message: "Email or password invalid.",
                  });
                }
                handleError(data.statusCode, {}, data.message || "");
              });
            } else {
              console.log({ logout_error: e });
              notification.warn({
                message:
                  e && e.message
                    ? e.message
                    : "Could not process your request at the moment. Please try again.",
              });
            }
          }
        }
      };
      const logoutResult = yield call(logout);

      // alert(forceLogout + " FORCE " + type);
      /*
      sessionStorage.removeItem("TC_USER");
      localStorage.removeItem("TC_USER");*/
      Storage.remove("TC_USER");
      localStorage.removeItem("TC_USER");
      sessionStorage.removeItem("TC_USER");
      onLogout();
      yield put({
        type: "setLoggedInUser",
        payload: {
          user: {},
        },
      });
      yield put({
        type: "setProjectLock",
        payload: { trackedProjectId: null, dismissed: false },
      });

      // TODO: fix needed, potentially a bug - intercom ghost company issue!
      let icSetting = getIntercomSettings(null, null);
      icSetting["company"] = {};
      icSetting["company"]["id"] = 0;
      window["intercomSettings"] = icSetting;

      try {
        if (window["Intercom"] != undefined) {
          window["Intercom"]("update", window["intercomSettings"]);
          window["Intercom"]("boot", window["intercomSettings"]);
        }
      } catch (e) {
        console.log({ Intercom_error: e });
      }

      // if (forceLogout) {
      //   location.pathname = "/login?type=" + type;
      // } else {
      //   location.pathname = "/login";
      // }
      location.pathname = "/login";
      // setTimeout(() => {
      //   debugger;
      //   location.pathname = "/login";
      // }, 500);
    },

    *pingServer({ payload }, { call, put, select }) {
      const loggedIn = yield select((state) => state.app.loggedIn);
      if (!loggedIn) {
        return;
      }
      console.info("Pinging server...");
    },
    *updateProjectSettingsByKey(
      { payload: { settings } },
      { call, put, select }
    ) {
      yield put({
        type: "setProjectSettingsByKey",
        payload: settings,
      });
    },
  },
};
